import { render, staticRenderFns } from "./course-threebox.vue?vue&type=template&id=153d1eb6"
import script from "./course-threebox.vue?vue&type=script&lang=js"
export * from "./course-threebox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports